<template>
	<b-row>
		<b-col cols="12" xl="12">
			<transition name="slide">
				<b-card no-header>
					<div slot="header" class="d-flex justify-content-between custom-card-header">
						<h5 class="card-header-title"> {{ $t('users-l.title') }}</h5>
						<b-alert
							class="mb-0"
							style="width: 300px;"
							v-if="statusResSuccess"
							:show="dismissCountDown"
							dismissible
							variant="success"
							@dismissed="dismissCountDown=0"
							@dismiss-count-down="countDownChanged"
						>
							<p>{{ deleteResponseSuccess }}</p>
						</b-alert>
						<b-alert
							class="mb-0"
							style="width: 300px;"
							v-if="notAllowedError"
							:show="dismissCountDown"
							dismissible
							variant="warning"
							@dismissed="dismissCountDown=0"
							@dismiss-count-down="countDownChanged"
						>
							<p>{{ deleteUserErrorMessage }}</p>
						</b-alert>
						<b-alert
							class="mb-0"
							style="width: 300px;"
							v-if="userExistError"
							:show="dismissCountDown"
							dismissible
							variant="warning"
							@dismissed="dismissCountDown=0"
							@dismiss-count-down="countDownChanged"
						>
							<p>{{ createUserErrorMessage }} This user already exist</p>
						</b-alert>
						<div class="card-header-actions">
							<div class="searchInCard">
								<b-form>
								<b-input-group size="sm">
									<b-form-input v-model="filter" size="sm" :placeholder="$t('contragent.filter')"
												  	autocomplete="off"/>
									<b-input-group-append>
										<b-button :disabled="!filter" @click="filter = ''">{{$t('contragent.clear')}}
										</b-button>
									</b-input-group-append>
								</b-input-group>
							</b-form>
							</div>
							<b-link @click="showCreateUserModal"
									size="sm"
									variant="primary"
									v-if="$can('create', 'user')"
							>
								<i class="fa fa-user-plus"
								   style="font-size: 1.2em; color: #53575B"></i>
							</b-link>
						</div>
					</div>
					<b-table class="generalTableClass" :hover="hover" :striped="striped" :bordered="bordered"
							 :small="small"
							 :fixed="fixed"
							 :filter="filter"
							 responsive="sm" :items="users" :fields="computedFields" :current-page="currentPage"
							 :per-page="0" show-empty>

						<!-- EMPTY SLOT FOR TABLE -->``
						<template slot="empty" slot-scope="scope">
							<h4>{{ $t('empty') }}</h4>
						</template>
						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="id" slot-scope="data">
							<strong>{{data.index+1}}</strong>
						</template>
						<template slot="name" slot-scope="data">
							<strong>{{data.item.name}}</strong>
						</template>
						<template slot="roleIds" slot-scope="data">
							<span id="userRoleNames"
								  v-for="(role, index) in userRoleName(data.item.id)"
							>
								<strong>
									{{ role.name }}<span v-if="index != userRoleName(data.item.id).length - 1">, </span>
								</strong>
							</span>
						</template>
						<template slot="departmentId" slot-scope="data">
							<span>{{getDepartmenForTable(data.item.employeeId)}}</span>
						</template>
						<template slot="employeeId" slot-scope="data">
							<span>{{getEmployeeForTable(data.item.employeeId)}}</span>
						</template>
						<template slot="contragentId" slot-scope="data">
							<span>{{getContragentForTable(data.item.contragentId)}}</span>
						</template>
						<template slot="status" slot-scope="data">

							<b-badge v-if="data.item.status == 'DELETED' || data.item.id == userIdStorage"
									 :variant="getBadge(data.item.status)">
								{{data.item.status}}
							</b-badge>

							<b-badge v-else-if="$can('change', 'user status') && data.item.username !== 'admin'"
									 :variant="getBadge(data.item.status)"
									 class="user-status-badge"
									 v-b-tooltip.hover :title="$t('users-l.update.status')"
									 @click="changeStatusOnTable(data.item.id, data.item.status)">
								{{data.item.status}}
							</b-badge>
							<b-badge v-else
									 :variant="getBadge(data.item.status)"
							>
								{{data.item.status}}
							</b-badge>

						</template>
						<template slot="actions" slot-scope="data">
							<b-link :key="data.item.id + 'delete'"
									@click="onOpen(data.item.id)"
									:disabled="data.item.status == 'DELETED' || data.item.id == userIdStorage || data.item.username == 'admin'"
									:id="'popOverDelete'+data.item.id"
									v-if="$can('delete', 'user')">
								<i class="fa fa-trash"></i>
							</b-link>
							<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
							<b-popover
								:key="data.item.id + 'popover'"
								:target="'popOverDelete'+data.item.id"
								placement="auto"
								container="myContainer"
								:ref="'popover'+data.item.id"
								class="refDeleteConfirm"
							>
								<template slot="title">
									<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
											  style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{$t('actions.deletetitle')}}
								</template>

								<div>
									<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                    <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block
													  @click="onClose(data.item.id)">{{$t('actions.no')}}
											</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block
													  @click="onOk(data.item.id)">{{$t('actions.yes')}}
											</b-button>
										</div>
									</div>
								</div>
							</b-popover>
							<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

							<b-link @click="updateUserOpenModal(data.item)" v-b-tooltip.hover
									:title="$t('actions.updateUser')"
									v-if="($can('change', 'passwords admin'))"
							>
								<i class="fa fa-edit"></i>
							</b-link>

							<b-link :key="data.item.id + 'depPermissions'"
									@click="openUserPermsModal(data.item.id)"
									:id="'depPermissions'+data.item.id"
									v-b-tooltip.hover
									:title="$t('actions.management')"
									v-if="$can('permit', 'to departments for user')"
							>
								<i class="fa fa-building-o"></i>
							</b-link>
						</template>
					</b-table>
					<b-row>
						<b-col>
							<nav>
								<b-pagination size="sm" :total-rows="total" :per-page="perPage"
											  v-model="currentPage" :prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')" hide-goto-end-buttons
								/>
							</nav>
						</b-col>
						<b-col cols="3">
							<b-form-group>
								<b-row>
									<b-col cols="3">
										<label :for="perPage">Лимит</label>
									</b-col>
									<b-col cols="9">
										<b-form-select v-model="perPage" :options="limits" value-field="id" text-field="name" size="sm"/>
									</b-col>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
					<!--<p>{{this.roleIds}}</p>  -&#45;&#45;   dddd-->

					<!--SAVE FORM ACTIONS-->
					<b-modal ref="createRoleModal" hide-footer ok-title="Save"
							 :title="$t('users-l.create.add-new-user')">
						<div style="margin: 25px;">
							<p v-if="roleInputNotFilled" style="color: red;">{{$t('users-l.create.please-title')}}</p>
							<p v-if="roleInputNotChage" style="color: red;">{{$t('users-l.update.please-title')}}</p>
							<p v-if="roleInputNotEmployee" style="color: red;">{{$t('users-l.create.employee')}}</p>

							<b-form-group
								label-align-sm="right"
								label-for="username"
								fa fa-user
								size="sm"
							>
								<b-input-group-prepend>
									<span class="input-group-text"><i class="fa fa-user fa-lg"></i></span>

									<b-form-input size="sm" :placeholder="$t('users-l.username')" type="text"
												  id="username"
												  v-model="item.username"/>
								</b-input-group-prepend>

							</b-form-group>

							<b-form-group
								label-for="password"
								size="sm">
								<b-input-group-prepend>
									<span class="input-group-text"><i class="fa fa-key"></i></span>
									<b-form-input size="sm" :placeholder="$t('users-l.create.password')" type="password"
												  id="password"
												  v-model="item.password"/>
								</b-input-group-prepend>
							</b-form-group>


							<b-form-group
								label-for="password"
								size="sm">
								<b-input-group-prepend>
									<span class="input-group-text"><i class="fa fa-key"></i></span>
									<b-form-input size="sm" :placeholder="$t('users-l.create.passwordChange')"
												  type="password"
												  id="passwordChange"
												  v-model="item.passwordChange"/>
								</b-input-group-prepend>
							</b-form-group>

							<b-form-checkbox
								ref="myCheckbox"
								id="checkboxStatus"
								v-model="statusCheck"
								@change="changeStatus(!statusCheck)"
							>
								{{$t('users-l.create.active')}}
							</b-form-checkbox>
							<fieldset style="color: black;margin-top: 5px" v-if="$can('add', 'role to user')">
								<span class="form-check-label" style="color: green; ">
								<mark style="background-color: white"><i style="color: green;" class="fa fa-check"></i>{{$t('users-l.create.roles')}}</mark>
								</span>
								<div class="row"
									 style="overflow-x: hidden;overflow-y: scroll; margin-left: -19px;margin-top: 8px;height: 200px; border: 1px solid rgb(164, 168, 171);overflow-y: scroll;">
									<div class="col-12" style="margin-left: 25px"
										 v-for="role in rolesList"
										 :key="role.id">
										<input class="form-check-input" :id="'role' + role.id" type="checkbox"
											   :value="role.id" v-model="item.roleIds" @change="roleName(role.name, role.id)"
												 :disabled="isContragent && role.name != 'Contragent'"
											>
										<label :for="'role' + role.id">{{role.name}}</label>

									</div>
								</div>
							</fieldset>
							<br>

							<b-form-group
								breakpoint="lg"
								label-size="sm"

								label-for="refName"
								class="required mb-1"
							>
								<multiselect v-if="!isContragent" v-model="itemLocal.employeeId"
											 :options="dropDowns.product.items"
											 :searchable="true"
											 :loading="dropDowns.product.loading"
											 :close-on-select="true"
											 :show-labels="false"
											 track-by="id"
											 :custom-label="userSelectedOption"
											 :internal-search="false"
											 @search-change="loadItems($event)"
											 @open="loadItems('')"
											 :placeholder="$t('users-l.create.employee')">

									<template slot="option" slot-scope="option">
										{{ option.option.firstName }} {{option.option.lastName}} -
										{{option.option.departmentName}}
									</template>
								</multiselect>

								<multiselect v-if="isContragent" v-model="itemLocal.contragentId"
											 :options="dropDowns.contragents.items"
											 :searchable="true"
											 :loading="dropDowns.contragents.loading"
											 :close-on-select="true"
											 :show-labels="false"
											 track-by="id"
											 :custom-label="contragentSelectedOption"
											 :internal-search="false"
											 @search-change="loadContragents($event)"
											 @open="loadContragents('')"
											 :placeholder="$t('users-l.create.contragent')">

									<template slot="option" slot-scope="option">
										{{ option.option.fullName }}
									</template>
								</multiselect>


							</b-form-group>

							<div class="row top mt-3 justify-content-end">
								<div class="col-4">
									<b-button variant="outline-danger" size="sm" block @click="closeCreateRoleModal">
										{{$t('actions.cancel')}}
									</b-button>
								</div>
								<div class="col-4">
									<b-button variant="outline-success" size="sm" block @click="saveSubmit">
										{{$t('actions.save')}}
									</b-button>
								</div>
							</div>
						</div>
					</b-modal>
					<!--UPADATE FORM ACTIONS-->
					<b-modal v-model="modalShowupdate" hide-footer ok-title="save">
						<div slot="modal-header">
							<h5 slot="modal-title" class="mb-0">{{ $t('users-l.update.title')
								}} - <strong>{{ currentUserName }}</strong></h5>
						</div>
						<div style="margin: 25px;">
							<p v-if="roleInputNotFilled" style="color: red;">{{$t('users-l.create.please-title')}}</p>
							<p v-if="roleInputNotChage" style="color: red;">{{$t('users-l.update.please-title')}}</p>

							<b-form-group
								label-align-sm="right"
								label-for="currentPassword"
								size="sm"
							>
								<b-input-group-prepend>
									<span class="input-group-text"><i class="fa fa-key"></i></span>
									<b-form-input
										size="sm"
										type="password"
										:placeholder="$t('users-l.update.password')"
										id="currentPassword"
										v-model="payload.currentPassword"/>
								</b-input-group-prepend>
							</b-form-group>
							<b-form-group
								label-align-sm="right"
								label-for="newPassword"
								size="sm">
								<b-input-group-prepend>
									<span class="input-group-text"><i class="fa fa-key"></i></span>
									<b-form-input size="sm" type="password"
												  :placeholder="$t('users-l.update.newpassword')"
												  id="newPassword"
												  v-model="payload.newPassword"/>
								</b-input-group-prepend>
							</b-form-group>
							<b-form-group
								label-align-sm="right"
								label-for="newPassword"
								size="sm">
								<b-input-group-prepend>
									<span class="input-group-text"><i class="fa fa-key"></i></span>
									<b-form-input size="sm" type="password"
												  :placeholder="$t('users-l.update.newPasswordChange')"
												  id="newPasswordchange"
												  v-model="payload.newPasswordChange"/>
								</b-input-group-prepend>
							</b-form-group>
							<fieldset style="color: black;margin-top: 8px" v-if="$can('add', 'role to user')">
								<span class="form-check-label" style="color: green; ">
								<mark style="background-color: white"><i style="color: green;" class="fa fa-check"></i>{{$t('users-l.create.roles')}}</mark>
								</span>
								<div class="row"
									 style=" margin-left: -19px; height: 200px;margin-top: 8px; border: 1px solid rgb(164, 168, 171);overflow-x: hidden;overflow-y: scroll;">
									<div class="col-12" style="padding-top: 10px;margin-left: 25px;"
										 v-for="role in rolesList"
										 :key="role.id">
										<input class="form-check-input" :id="'roleUpdate' + role.id" type="checkbox"
											   :value="role.id" v-model="payload.roleIds"
												 	@change="roleName(role.name, role.id)"
													:disabled="isContragent && role.name != 'Contragent'"
										>
										<label :for="'roleUpdate' + role.id">{{role.name}}</label>

									</div>
								</div>
							</fieldset>
							<br>
							<b-form-group
								breakpoint="lg"
								label-size="sm"

								label-for="refName"
								class="required mb-1"
							>
								<multiselect v-if="!isContragent"  v-model="payload.employeeId"
											 :options="dropDowns.product.items"
											 :searchable="true"
											 :loading="dropDowns.product.loading"
											 :close-on-select="true"
											 :custom-label="userSelectedOption"
											 label="firstName"
											 :internal-search="false"
											 track-by="id"
											 @search-change="loadItems($event)"
											 @open="loadItems('')"
											 :placeholder="$t('users-l.create.employee')">

									<template slot="option" slot-scope="option">
										{{ option.option.firstName }} {{option.option.lastName}} -
										{{option.option.departmentName}}
									</template>
								</multiselect>
								<multiselect v-if="isContragent" v-model="payload.contragentId"
											 :options="dropDowns.contragents.items"
											 :searchable="true"
											 :loading="dropDowns.contragents.loading"
											 :close-on-select="true"
											 :show-labels="false"
											 track-by="id"
											 :custom-label="contragentSelectedOption"
											 :internal-search="false"
											 @search-change="loadContragents($event)"
											 @open="loadContragents('')"
											 :placeholder="$t('users-l.create.contragent')">

									<template slot="option" slot-scope="option">
										{{ option.option.fullName }}
									</template>
								</multiselect>
								<!--<span>{{this.payload.employeeId}}</span>-->
							</b-form-group>
							<div class="row top mt-3 justify-content-end">
								<div class="col-4">
									<b-button size="sm" variant="outline-danger" block
											  @click="closeUpdateUserOpenModal">
										{{$t('actions.cancel')}}
									</b-button>
								</div>
								<div class="col-4">
									<b-button size="sm" variant="outline-success" block @click="updateSubmit">
										{{$t('actions.save')}}
									</b-button>
								</div>
							</div>

						</div>
					</b-modal>

					<!-- USER PERMISSIONS MODAL -->
					<b-modal v-model="showUserPermModal"
							 @ok="addOrUpdateUserPerms"
							 hide-footer
							 ok-title="save"
							 :title="$t('actions.management-title')">
						<user-permissions
							@closeUserPermModal="closeUserPermModal"
							@savePermittedData="addOrUpdateUserPerms"
							:departmentsForTree="getDepartments"
							:isModalOpened="isPermModalOpened">
						</user-permissions>
					</b-modal>
					<!-- USER PERMISSIONS MODAL -->

				</b-card>
			</transition>
		</b-col>
	</b-row>
</template>

<script>
	import {mapActions, mapGetters, mapState} from "vuex";
	import AddUser from './userComponents/addUser'
	import UserPermissions from './userComponents/UserPermissionsModal'
	import Multiselect from 'vue-multiselect'
	import EmployeeSerive from "../../../services/employees.service";
	import ContrAgentService from "../../../services/contragent.service";

	export default {
		name: 'Users',
		components: {
			AddUser,
			UserPermissions,
			Multiselect
		},

		props: {
			caption: {
				type: String,
				default: 'Users'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},


		data: () => {
			return {
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' USER BEGIN */
				contragentId: null,
				isContragent: false,
				isValid: false,
				dismissCountDown: 4,
				counterForAlert: 0,
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' USER END */
				userIdStorage: JSON.parse(localStorage.userId),
				currentUserName: '',
				statusCheck: true,
				dropDowns: {
					product: {
						items: [],
						value: null,
						loading: false,
						search: {
							page: 1,
							limit: 2000,
							attributes: [{
								field: 'firstName',
								value: '',
								option: 'CONTAINS'
							}]
						}
					},
					contragents: {
						items: [],
						value: null,
						loading: false,
						search: {
							page: 1,
							limit: 100,
							attributes: []
						}
					},

				},
				filter: '',
				arrayName: [],
				payload: {
					id: null,
					currentPassword: '',
					newPassword: '',
					newPasswordChange: '',
					employeeId: '',
					roleIds: [],
					contragentId: null,
				},
				isCheck: false,
				options: [
					{value: 'ACTIVE', text: 'ACTIVE'},
					// {value: 'INACTIVE', text: 'INACTIVE'}
				],
				modalShow: false,
				modalShowupdate: false,
				showUserPermModal: false,
				fields: [
					{key: 'id'},
					{key: 'name'},
					{key: 'roleIds'},
					{key: 'status'},
					{key: 'role'},
					{key: 'status'}
				],
				fieldsforuser: [
					{key: 'id'},
					{
						key: 'username',
						'class': 'width30_wordBreak'
					},
					{
						key: 'status',
						'class': 'width30_wordBreak'
					},
					{
						key: 'roleIds',
						'class': 'width30_wordBreak'
					},
					{
						key: 'actions',
						'class': 'table_actions'
					}

				],
				itemLocal: {
					username: '',
					password: '',
					passwordChange: '',
					status: 'ACTIVE',
					employeeId: null,
					contragentId: null,
					roleIds: [],
				},
				currentPage: 1,
				perPage: 100,
				limits: [
					{name: 50, id: 50},
					{name: 100, id: 100},
					{name: 150, id: 150},
					{name: 200, id: 200},
					{name: 500, id: 500},
					// {name: 'Все', id: this.total}
				],
				totalRows: 0,
				focusedId: null,
				roleInputNotFilled: false,
				/* CURRENT USER ID */
				currentUserId: null,
				isPermModalOpened: false,
				roleInputNotChage: false,
				roleInputNotEmployee: false,
			}

		},
		computed: {
			...mapGetters('users', [
				'users', 'total', 'deleteResponseSuccess'
			]),
			...mapGetters('contragents', [
				'contragents'
			]),
			...mapState('users', [
				'hasPasswordError', 'passwordErrorMessage',
				'notAllowedError', 'deleteUserErrorMessage', 'userExistError', 'createUserErrorMessage', 'statusText', 'statusRes', 'statusResSuccess'
			]),
			...mapGetters('departments', [
				'getDepartments'
			]),
			...mapGetters('roles', [
				'rolesList'
			]),

			item() {
				return this.itemLocal;
			},
			computedFields() {
				return [
					{
						key: 'id',
						label: this.$t('users-l.Id'),
						'class': 'role_id',
						sortable: true
					},
					{
						key: 'username',
						label: this.$t('users-l.username')
					},
					{
						key: 'roleIds',
						label: this.$t('users-l.create.roles')
					},
					{
						key: 'departmentId',
						label: this.$t('sidebar.organization-structure.departments')
					},
					{
						key: 'employeeId',
						label: this.$t('employees.title')
					},
					{
						key: 'contragentId',
						label: this.$t('sale.contragent')
					},
					{
						key: 'status',
						label: this.$t('users-l.status')
					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions'

					},

				]
			}

		},

		async mounted() {
			let paramsForUsers = {
				page: this.currentPage,
				limit: this.perPage,
				value: this.filter
			};
			await this.fetchUsers(paramsForUsers);
			// this.userRoleName();
		},
		async created() {
			await this.getRolesList();
			await this.loadItems('');
			await  this.loadContragents('')
		},
		watch: {
			currentPage: {
				handler() {
					let paramsForUsers = {
						page: this.currentPage,
						limit: this.perPage
					}
					this.fetchUsers(paramsForUsers)
				}
			},
			perPage: {
				handler(e) {
					let paramsForUsers = {
						page: this.currentPage,
						limit: e
					}
					this.fetchUsers(paramsForUsers)
				}
			},
			users: {
				handler() {
					let paramsForUsers = {
						page: this.currentPage,
						limit: this.perPage
					};
					if (this.users.length < 1) {
						this.fetchUsers(paramsForUsers)
					}
				}
			}
		},

		methods: {
			roleName(name, id) {
				if(name == 'Contragent') {
					this.isContragent = !this.isContragent
					if(this.isContragent) {
						if(this.item.roleIds.length > 1 || 	this.payload.roleIds.length > 1) {
							this.item.roleIds = this.item.roleIds.filter(el => el == id)
							this.payload.roleIds = this.payload.roleIds.filter(el => el == id)
						}
						this.payload.employeeId = null
						this.itemLocal.employeeId = null
					}else {
						this.itemLocal.contragentId = null
						this.payload.contragentId = null
					}
				}
			},
			...mapActions('users', [
				'fetchUsers', 'deleteUserStore',
				'createUserStore',
				'updateUserBy',
				'updateUserByRoles',
				'updateUserByEmployeeStore',
				'updateUserByContragentStore',
				'updateUserStatus',
				'getPermittedDepartments',
				'postPermittedDepartments'
			]),
			...mapActions('departments', [
				'getDepartmentsList'
			]),
			...mapActions('roles', [
					'getRolesList'
				],
			),
			...mapActions('contragents', [
					'fetchContragents']),
			/* POPOVER METHODS BEGIN */
			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},

			loadItems($event) {
				this.dropDowns.product.loading = true;
				if ($event.length == 0) {
					this.dropDowns.product.search.attributes[0].value = $event;
					EmployeeSerive.search(this.dropDowns.product.search).then(response => {
						this.dropDowns.product.items = response.data.items;
						this.dropDowns.product.loading = false;
					})
				} else {
					EmployeeSerive.searchEmployee($event).then(response => {
						this.dropDowns.product.items = response.data;
						this.dropDowns.product.loading = false;
					})
				}


			},
			loadContragents($event) {
				this.dropDowns.contragents.loading = true;
				if ($event.length == 0) {
					// this.dropDowns.contragents.search.attributes[0].val = $event;
					ContrAgentService.search(this.dropDowns.contragents.search).then(response => {
						this.dropDowns.contragents.items = response.data.items;
						this.dropDowns.contragents.loading = false;
					})
				} else {
					ContrAgentService.search($event).then(response => {
						this.dropDowns.contragents.items = response.data;
						this.dropDowns.contragents.loading = false;
					})
				}
			},
			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async onOk(itemId) {
				this.onClose(itemId);
				await this.userDelete(itemId);
			},
			/* POPOVER METHODS END */

			countDownChanged(dismissCountDown) {
				if (dismissCountDown <= 1) {
					dismissCountDown = 3;
				}
				this.dismissCountDown = dismissCountDown
			},
			changeStatus(isActive) {
				// let isActive = this.$refs.myCheckbox.value;
				if (isActive) {
					this.itemLocal.status = 'ACTIVE';
				}
				else {
					this.itemLocal.status = 'INACTIVE';
				}
			},
			async changeStatusOnTable(userId, currentStatus) {
				let payload = {
					id: userId
				};
				if (currentStatus === 'ACTIVE') {
					payload.status = 'INACTIVE'
				} else {
					payload.status = 'ACTIVE'
				}
				await this.updateUserStatus(payload);
				let paramsForUsers = {
					page: this.currentPage,
					limit: this.perPage
				};
				setTimeout(() => {
					this.fetchUsers(paramsForUsers);
				}, 100);
			},
			getBadge(status) {
				return status === 'ACTIVE' ? 'success'
					: status === 'INACTIVE' ? 'secondary'
						: status === 'PENDING' ? 'warning'
							: status === 'DELETED' ? 'danger' : 'primary'
			},
			/* USER PERMISSIONS FUNCTIONS BEGIN */
			async openUserPermsModal(userId) {
				this.isPermModalOpened = true;
				this.currentUserId = userId;
				if (this.$can('list', 'departments')) {
					await this.getDepartmentsList();
				}
				if (this.$can('get', 'permitted departments')) {
					await this.getPermittedDepartments(userId);
				}
				this.showUserPermModal = true;
			},
			closeUserPermModal() {
				this.showUserPermModal = false;
				this.isPermModalOpened = false
			},
			async addOrUpdateUserPerms(payload) {
				this.isPermModalOpened = false;
				this.showUserPermModal = false;
				let idAndPayload = {
					id: this.currentUserId,
					payload: payload
				};
				await this.postPermittedDepartments(idAndPayload);
			},
			/* USER PERMISSIONS FUNCTIONS END */

			async saveSubmit() {
				if (this.item.username != '' && this.item.password != '' && this.item.passwordChange != '') {
					if (this.item.password === this.item.passwordChange && (this.itemLocal.employeeId || this.itemLocal.contragentId )) {
						if(this.itemLocal.employeeId) {
							this.itemLocal.employeeId = this.itemLocal.employeeId.id;
						}
						if(this.itemLocal.contragentId) {
							this.itemLocal.contragentId = this.itemLocal.contragentId.id
						}
						this.roleInputNotFilled = false;
						if (this.item.roleIds.length < 1) {
							delete this.item.roleIds;
						}
						await this.createUserStore(this.item);
						let paramsForUsers = {
							page: this.currentPage,
							limit: this.perPage
						};
						this.$refs.createRoleModal.hide();
						this.fetchUsers(paramsForUsers);


						if (this.userExistError) {
							setTimeout(() => {
								this.$store.commit('users/createUserError', {message: '', boolean: false})
							}, 4000)
						}
						this.itemLocal.username = '';
						this.itemLocal.password = '';
						this.itemLocal.passwordChange = '';
						this.itemLocal.roleIds = [];
						this.itemLocal.employeeId = '';
						this.itemLocal.status = 'INACTIVE';
						this.statusCheck = true;

					} else if (!this.itemLocal.employeeId) {
						this.roleInputNotChage = false;
						this.roleInputNotFilled = false;
						this.roleInputNotEmployee = true;
						this.isValid = true;
					} else {
						this.roleInputNotChage = true;
						this.roleInputNotEmployee = false;
						this.roleInputNotFilled = false;

					}
				} else {
					this.roleInputNotEmployee = false;
					this.roleInputNotFilled = true;
					this.roleInputNotChage = false;
				}
			},
			updateUserOpenModal(data) {
				this.currentUserName = data.username;
				this.roleInputNotFilled = false;
				this.roleInputNotChage = false;
				this.payload.id = data.id;
				this.modalShowupdate = true;
				this.payload.currentPassword = '';
				this.payload.newPassword = '';
				this.payload.newPasswordChange = '';
				this.payload.roleIds = data.roleIds ? data.roleIds : [];
				if(data.contragentId) {
					ContrAgentService.search(this.dropDowns.contragents.search).then(response => {
						this.dropDowns.contragents.items = response.data.items;
						this.dropDowns.contragents.loading = false;
					})
					this.payload.contragentId = this.dropDowns.contragents.items.find(el => {
							return el.id == data.contragentId;
					});
					this.payload.employeeId = null;
				}
				if(data.employeeId) {
					EmployeeSerive.search(this.dropDowns.product.search).then(response => {
						this.dropDowns.product.items = response.data.items;
						// this.payload.employeeId = response.data.items;
						this.dropDowns.product.loading = false;
					})
					this.payload.employeeId = this.dropDowns.product.items.find(el => {
						return el.id == data.employeeId;
					});
					this.payload.contragentId = null
				}
				this.rolesList.forEach(el => {
					if(data.roleIds.indexOf(el.id) > -1) {
						if(el.code == 'Contragent') {
							this.isContragent = true
						}else {
							this.isContragent = false
						}
					}
				})
				// this.itemLocal.employeeId = data.employeeId;
			},
			getDepartmenForTable(employeeId){
				let fullName;
				this.dropDowns.product.items.forEach(item=>{
					if (employeeId==item.id){
						fullName  =item.departmentName
					}
				})
				return fullName

			},
			getContragentForTable(contragentId){
				let fullName;
				this.dropDowns.contragents.items.forEach(item=>{
					if (contragentId == item.id){
						fullName  = item.fullName
					}
				})
				return fullName

			},
			getEmployeeForTable(employeeId){
				let fullName;
				this.dropDowns.product.items.forEach(item=>{
					if (employeeId==item.id){
						fullName  =item.firstName+' '+item.lastName
					}
				})
				return fullName

			},
			onChangeCheckbox(id) {
				/* CHECKBOX CHANGE BO'LGANDA ISHLAYDI */
				this.payloadArray.id = id;

			},
			async updateSubmit() {
				await this.onUpdateUserById();
			},
			closeCreateRoleModal() {
				this.roleInputNotFilled = false;
				this.$refs.createRoleModal.hide();
			},
			closeUpdateUserOpenModal() {
				this.modalShowupdate = false;
				this.isContragent = false;
				this.currentUserName = '';
			},

			async userDelete(id) {
				await this.deleteUserStore(id);
				if (this.statusResSuccess) {
					setTimeout(() => {
						this.$store.commit('users/deleteSuccess', {deleteResponse: {statusText: ''}, boolean: false})
					}, 2000)
				}

				if (this.notAllowedError) {
					setTimeout(() => {
						this.$store.commit('users/deleteUserError', {message: '', boolean: false})
					}, 5000)
				}
				// this.fetchUsers();
			},
			async onUpdateUserById() {
						if(this.payload.roleIds.length) {
							if(this.payload.employeeId) {
								await this.updateUserByRoles(this.payload);
								await this.updateUserByEmployeeStore(this.payload);
								this.modalShowupdate = false;
								this.roleInputNotChage = false;
								this.roleInputNotFilled = true;
							}else {
								if(!this.isContragent) {
									this.$vs.notify({
										title:"Выберите сотрудника",
										color: 'warning',
										icon: 'close',
										position: 'top-right'
									});
								}
							}
						}else {
							if(!this.isContragent) {
								this.$vs.notify({
									title:"Выберите роль",
									color: 'warning',
									icon: 'close',
									position: 'top-right'
								});
							}
						}
						if(this.payload.roleIds.length) {
							if(this.payload.contragentId) {
								await this.updateUserByRoles(this.payload);
								await this.updateUserByContragentStore(this.payload)
								this.modalShowupdate = false;
								this.roleInputNotChage = false;
								this.roleInputNotFilled = true;
							}else {
								if(this.isContragent) {
									this.$vs.notify({
										title: "Выберите контрагента",
										color: 'warning',
										icon: 'close',
										position: 'top-right'
									});
								}
							}
						}else {
							if(this.isContragent) {
								this.$vs.notify({
									title: "Выберите роль",
									color: 'warning',
									icon: 'close',
									position: 'top-right'
								});
							}
						}
						/*this.payload.employeeId = this.dropdowns.product.items.find(el => {
														return el.id == this.payload.employeeId;
												})*/
						// this.modalShowupdate = false;
						let paramsForUsers = {
							page: this.currentPage,
							limit: this.perPage
						};
						await this.fetchUsers(paramsForUsers);
						if (this.payload.currentPassword != '' && this.payload.newPassword != ''
						 && this.payload.newPasswordChange != '') {
							if (this.payload.newPassword !== this.payload.newPasswordChange) {
									this.roleInputNotChage = true;
									this.roleInputNotFilled = false;
									this.modalShowupdate = true;
									this.$vs.notify({
										title: 'Этот пароль не совпадает с паролем, введенным в поле пароля, попробуйте еще раз',
										color: 'warning',
										icon: 'close',
										position: 'top-right'
									});
							}else {
									await this.updateUserBy(this.payload);
									if(this.hasPasswordError) {
										this.roleInputNotChage = true;
										this.roleInputNotFilled = false;
										this.modalShowupdate = true;
										this.$vs.notify({
											title: 'Неверный пароль',
											color: 'warning',
											icon: 'close',
											position: 'top-right'
										});
									}else{
										this.modalShowupdate = false;
										this.roleInputNotChage = false;
										this.roleInputNotFilled = true;
									}
							}
						}
			},
			showCreateUserModal() {
				this.itemLocal.username = '';
				this.itemLocal.password = '';
				this.itemLocal.passwordChange = '';
				this.itemLocal.roleIds = [];
				this.itemLocal.employeeId = '';
				this.itemLocal.contragentId = '';
				this.itemLocal.status = 'ACTIVE';
				this.statusCheck = true;
				this.roleInputNotFilled = false;
				this.roleInputNotChage = false;
				this.isContragent = false;
				this.$refs.createRoleModal.show();
			},

			userRoleName(userId) {
				let tempArray = [];
				let currentUserIndex = this.users.findIndex(el => {
					return el.id == userId;
				});
				let currentUser = this.users[currentUserIndex];
				if (currentUser.roleIds) {
					tempArray = this.rolesList.filter(({id}) => currentUser.roleIds.includes(id));
				}
				return tempArray;


			},
			userEmployee(employeeId) {
				let tempArrEmp = [];
				let currentUserIndex = this.users.findIndex(el => {
					return el.id == userId;
				});
				let currentUser = this.users[currentUserIndex];
				if (currentUser.employeeId) {
					tempArrEmp = this.getemployees.filter(({id}) => currentUser.roleIds.includes(id));
				}
				return tempArrEmp;
			},
			userSelectedOption (user) {
				return user.firstName + ' ' + user.lastName + ' - ' + user.departmentName;
			},
			contragentSelectedOption (contragent) {
				return contragent.fullName
			}

		}, // METHODS END
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
	.user-status-badge {
		cursor: pointer;
	}

</style>
